import { call, put, select } from 'redux-saga/effects';
import { HIDE_SPINNER } from '../../redux/modules/spinner/spinner';
import { retriable } from '../retriable';
import {
    didApiCallFailDueToUnauthorizedUser, didApiCallFailDueToVersionMismatch,
    getErrorMessage,
    isValidFunction,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import { ERROR_MESSAGE } from '../../redux/modules/message/message-actions';
import messages from '../../constants/messages';
import {
    FETCH_BUNDLES_SUCCESS,
    FETCH_BUNDLES_FAILURE,
} from '../../redux/modules/bundles/bundles-actions';
import {
    getClaimListConstruct,
} from '../../components/PayerComponents/ClaimsList/ClaimsListUtil';
import { addSeekDirectionAndParamsToUrlParams } from '../../constants/UrlUtil';
import { getStringFromObject } from '../../constants/lodashUtils';

const getClaimPrefix = state => getStringFromObject('appConfiguration.claimPrefix', state);

export default function* fetchBundleListWorker(action) {
    const {
        api,
        page,
        size,
        filters,
        searchFilter,
        seekDirection,
        seekParams,
        isBundle,
    } = action;
    try {
        const config = {
            headers: { 'Content-Type': 'application/json' },
        };
        // yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const claimPrefix = yield select(getClaimPrefix);
        const searchConstruct = getClaimListConstruct(filters, searchFilter, isBundle, claimPrefix);

        const apiWithParams = addSeekDirectionAndParamsToUrlParams(
            `${api}?page=${page}&size=${size}`, seekDirection, seekParams);

        const response = yield call(retriable().post, apiWithParams, searchConstruct, config);
        yield put({
            type: FETCH_BUNDLES_SUCCESS,
            data: {
                ...response.data,
                size,
                page,
                isBundle,
            },
            filters: action.filters,
        });
        if (isValidFunction(action.successCallback)) {
            action.successCallback(response.data);
        }
        // yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        // do error action
        console.error('error in bundle/claims', e);
        if (isValidFunction(action.failureCallBack)) {
            action.failureCallBack();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: `${messages.CLAIMS.FETCH_FAILED}: ${getErrorMessage(e)}`,
            });
        }
        yield put({
            type: FETCH_BUNDLES_FAILURE,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}
